var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 598,
    height: 552,
    viewBox: "0 0 598 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29501_30294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.551 256.494H138.281C138.281 263.062 135.715 269.78 130.656 276.463C126.144 282.42 119.717 288.318 111.552 293.991C97.0121 304.095 82.0972 309.847 81.9482 309.904L85.6008 319.513C85.6008 319.513 148.552 295.595 148.552 256.494H148.551Z",
    fill: "url(#paint0_linear_29501_30294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.307 138.378L515.289 136.118L515.308 136.037C515.282 136.143 512.612 146.791 502.548 157.16C496.696 163.19 489.464 168.003 481.055 171.469C470.24 175.926 457.389 178.186 442.855 178.186V188.467C514.033 188.467 525.307 138.378 525.307 138.378Z",
    fill: "url(#paint1_linear_29501_30294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.757 328.458H449.886C446.105 328.458 443.039 325.389 443.039 321.604C443.039 317.819 446.105 314.75 449.886 314.75H510.757C514.538 314.75 517.604 317.819 517.604 321.604C517.604 325.389 514.538 328.458 510.757 328.458Z",
    fill: "#17414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.501 266.775H551.468V256.494H530.501C518.182 256.494 506.275 259.129 495.105 264.328C483.943 269.521 474.261 276.93 466.324 286.348L392.829 372.738L402.346 380.851L474.158 292.996C488.161 276.37 508.779 266.775 530.503 266.775H530.501Z",
    fill: "#275866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.466 266.775V277.056H530.499C511.76 277.056 494.084 285.281 482.006 299.622L481.973 299.662L422.756 369.267C422.756 369.267 415.198 372.675 407.881 375.571C402.955 377.52 397.616 373.883 397.616 368.58C409.354 365.872 419.883 359.394 427.508 350.064L474.154 292.996C488.157 276.369 508.775 266.775 530.499 266.775H551.466Z",
    fill: "url(#paint2_linear_29501_30294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.281 410.598C265.094 401.818 254.7 394.956 242.381 390.199C228.395 384.799 211.721 382.061 192.823 382.061H112.856V392.341H192.823C288.656 392.341 283.622 465.404 283.622 465.404V552.002H293.892V465.675C294.077 461.676 294.566 433.43 273.279 410.6L273.281 410.598Z",
    fill: "#17414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.825 392.34H112.858V402.62H192.825C222.487 402.62 244.439 409.954 258.072 424.417C264.889 431.649 269.534 440.542 271.879 450.849C273.629 458.533 273.377 464.719 273.377 464.719L273.35 525.322C273.35 530.688 270.236 535.097 265.68 538.675C259.752 543.33 252.393 545.777 244.858 545.777H212.524C207.454 545.777 202.42 546.644 197.643 548.342L187.353 551.998H283.624V465.401C283.624 465.401 288.656 392.338 192.825 392.338V392.34Z",
    fill: "url(#paint3_linear_29501_30294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.512 374.712H525.307V364.432H436.512C415.666 364.432 397.291 367.447 381.891 373.393C368.375 378.612 356.974 386.138 348.001 395.76C324.59 420.869 325.218 451.927 325.418 456.118V551.999H335.688V455.841C335.688 455.841 330.099 374.711 436.512 374.711V374.712Z",
    fill: "#17414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.512 374.713C330.1 374.713 335.688 455.843 335.688 455.843V552.001H431.954L421.664 548.345C416.885 546.647 411.853 545.78 406.783 545.78H374.449C366.917 545.78 359.555 543.333 353.628 538.678C349.073 535.1 345.958 530.691 345.958 525.325V455.49L345.934 455.137C345.93 455.077 345.576 448.939 347.44 440.266C349.994 428.39 355.235 418.138 363.016 409.792C369.85 402.462 378.689 396.671 389.284 392.579C402.316 387.547 418.205 384.995 436.512 384.995H525.308V374.715H436.512V374.713Z",
    fill: "url(#paint4_linear_29501_30294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.437 168.857H335.744V355.983H349.437V168.857Z",
    fill: "#17414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.606 336.782C371.825 336.782 368.76 333.713 368.76 329.928V220.615C368.76 216.83 371.825 213.762 375.606 213.762C379.387 213.762 382.453 216.83 382.453 220.615V329.928C382.453 333.713 379.387 336.782 375.606 336.782Z",
    fill: "#17414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.622 268.862C404.841 268.862 401.775 265.793 401.775 262.008V188.467C401.775 184.682 404.841 181.613 408.622 181.613C412.403 181.613 415.468 184.682 415.468 188.467V262.008C415.468 265.793 412.403 268.862 408.622 268.862Z",
    fill: "#17414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.143 280.332H176.53C169.708 280.332 163.166 277.619 158.341 272.789L120.391 234.798C115.568 229.97 109.024 227.256 102.202 227.256H65.498V237.537H102.202C106.33 237.537 110.211 239.145 113.129 242.067L151.079 280.057C154.439 283.421 158.367 286.048 162.755 287.867C167.144 289.687 171.779 290.61 176.529 290.61H217.429C223.514 290.61 228.449 295.549 228.449 301.642V302.946L235.141 280.33L235.143 280.332Z",
    fill: "#17414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.393 234.798L158.343 272.789C163.167 277.617 169.71 280.331 176.533 280.331H229.29V270.051H176.533C172.404 270.051 168.524 268.442 165.606 265.52L127.656 227.53C124.296 224.166 120.368 221.539 115.979 219.72C111.591 217.9 106.956 216.977 102.206 216.977H65.502V227.257H102.206C109.028 227.257 115.57 229.97 120.395 234.8L120.393 234.798Z",
    fill: "url(#paint5_linear_29501_30294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.299 387.805C310.299 379.63 308.072 371.606 303.857 364.603C299.643 357.6 293.599 351.879 286.379 348.058L263.18 335.778C254.427 331.145 248.987 322.108 248.987 312.196V95.2207H238.718V312.196C238.718 325.892 246.285 338.465 258.379 344.868L281.578 357.146C292.928 363.154 300.028 374.953 300.028 387.805V551.999H310.297V387.805H310.299Z",
    fill: "#17414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.58 357.146L258.381 344.868C246.287 338.466 238.72 325.893 238.72 312.196V95.2207H228.45V312.196C228.45 320.785 230.79 329.214 235.218 336.571C239.646 343.929 245.996 349.94 253.58 353.954L276.779 366.235C284.786 370.472 289.76 378.738 289.76 387.805V520.671C289.76 545.192 267.145 551.998 267.145 551.998H308.552V435.081C308.552 401.353 306.561 369.85 281.579 357.145L281.58 357.146Z",
    fill: "url(#paint6_linear_29501_30294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.274 357.147L360.473 344.869C372.567 338.467 380.134 325.894 380.134 312.197V302.848C380.134 285.434 389.841 269.474 405.293 261.479L417.694 255.062C433.148 247.065 442.853 231.106 442.853 213.692V73.4727H432.583V213.691C432.583 220.349 430.755 226.874 427.296 232.561C423.837 238.248 418.887 242.871 412.978 245.927L400.578 252.344C391.321 257.133 383.564 264.374 378.147 273.284C372.728 282.194 369.864 292.417 369.864 302.848V312.197C369.864 322.109 364.427 331.146 355.672 335.779L332.473 348.059C325.253 351.88 319.209 357.601 314.995 364.604C310.781 371.607 308.553 379.629 308.553 387.806V552H318.822V387.806C318.822 374.953 325.922 363.155 337.272 357.147H337.274Z",
    fill: "url(#paint7_linear_29501_30294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.854 73.4727V213.691C442.854 231.104 433.147 247.065 417.695 255.06L405.294 261.477C389.84 269.474 380.135 285.433 380.135 302.846V312.195C380.135 325.891 372.568 338.464 360.474 344.867L337.275 357.145C325.925 363.153 308.554 374.71 308.554 403.479V551.997H351.709C351.709 551.997 329.093 541.512 329.093 520.67V387.804C329.093 378.737 334.067 370.473 342.074 366.234L365.273 353.953C372.859 349.939 379.207 343.928 383.635 336.57C388.063 329.213 390.403 320.784 390.403 312.195V302.846C390.403 296.188 392.231 289.663 395.69 283.976C399.149 278.289 404.099 273.666 410.008 270.61L422.409 264.193C431.665 259.404 439.422 252.163 444.839 243.253C450.258 234.343 453.122 224.12 453.122 213.689V73.4727H442.852H442.854Z",
    fill: "url(#paint8_linear_29501_30294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.307 138.379C525.307 138.379 516.65 176.818 466.65 186.347C458.347 187.896 453.123 183.772 453.123 178.527H447.692L448.844 209.129H453.123C453.123 203.214 457.45 198.176 463.297 197.327C472.867 195.935 481.723 193.523 489.772 190.108C500.891 185.389 510.478 178.777 518.267 170.453C531.51 156.298 534.974 142.202 535.325 140.641L525.307 138.381V138.379Z",
    fill: "#17414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.446 262.256C142.922 267.737 143.553 276.431 138.88 282.613C121.232 305.971 85.5996 319.509 85.5996 319.509L89.2436 329.121C89.9334 328.859 106.336 322.567 122.906 311.125C132.934 304.201 140.999 296.78 146.879 289.071C149.549 285.567 151.776 282 153.554 278.379C155.822 267.243 146.276 262.254 137.446 262.254V262.256Z",
    fill: "#17414C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.767 301.044C582.673 301.044 598 285.701 598 266.775C598 247.849 582.673 232.506 563.767 232.506C544.861 232.506 529.535 247.849 529.535 266.775C529.535 285.701 544.861 301.044 563.767 301.044Z",
    fill: "#FFB772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.464 409.094C552.37 409.094 567.696 393.752 567.696 374.826C567.696 355.899 552.37 340.557 533.464 340.557C514.558 340.557 499.231 355.899 499.231 374.826C499.231 393.752 514.558 409.094 533.464 409.094Z",
    fill: "#FFB772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.36 214.021C568.813 214.021 576.476 206.349 576.476 196.886C576.476 187.423 568.813 179.752 559.36 179.752C549.907 179.752 542.244 187.423 542.244 196.886C542.244 206.349 549.907 214.021 559.36 214.021Z",
    fill: "#52A8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.96 220.259C302.413 220.259 310.076 212.588 310.076 203.125C310.076 193.662 302.413 185.99 292.96 185.99C283.507 185.99 275.844 193.662 275.844 203.125C275.844 212.588 283.507 220.259 292.96 220.259Z",
    fill: "#C72430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.96 266.853C302.413 266.853 310.076 259.182 310.076 249.718C310.076 240.255 302.413 232.584 292.96 232.584C283.507 232.584 275.844 240.255 275.844 249.718C275.844 259.182 283.507 266.853 292.96 266.853Z",
    fill: "#FFB772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.116 472.269C517.569 472.269 525.232 464.598 525.232 455.134C525.232 445.671 517.569 438 508.116 438C498.663 438 491 445.671 491 455.134C491 464.598 498.663 472.269 508.116 472.269Z",
    fill: "#C72430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.407 452.218C169.86 452.218 177.523 444.547 177.523 435.084C177.523 425.621 169.86 417.949 160.407 417.949C150.954 417.949 143.291 425.621 143.291 435.084C143.291 444.547 150.954 452.218 160.407 452.218Z",
    fill: "#50AD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.538 347.062C164.991 347.062 172.654 339.391 172.654 329.927C172.654 320.464 164.991 312.793 155.538 312.793C146.085 312.793 138.422 320.464 138.422 329.927C138.422 339.391 146.085 347.062 155.538 347.062Z",
    fill: "#52A8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.866 166.307C544.772 166.307 560.098 150.965 560.098 132.038C560.098 113.112 544.772 97.7695 525.866 97.7695C506.96 97.7695 491.634 113.112 491.634 132.038C491.634 150.965 506.96 166.307 525.866 166.307Z",
    fill: "#C72430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.855 124.159C473.104 124.159 497.626 99.6102 497.626 69.3283C497.626 39.0464 473.104 14.498 442.855 14.498C412.605 14.498 388.083 39.0464 388.083 69.3283C388.083 99.6102 412.605 124.159 442.855 124.159Z",
    fill: "#C72430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.592 186.346C361.498 186.346 376.824 171.004 376.824 152.077C376.824 133.151 361.498 117.809 342.592 117.809C323.686 117.809 308.359 133.151 308.359 152.077C308.359 171.004 323.686 186.346 342.592 186.346Z",
    fill: "#C72430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.859 423.2C129.885 423.2 143.687 409.383 143.687 392.339C143.687 375.295 129.885 361.479 112.859 361.479C95.8334 361.479 82.0312 375.295 82.0312 392.339C82.0312 409.383 95.8334 423.2 112.859 423.2Z",
    fill: "#C72430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5993 350.372C102.625 350.372 116.427 336.555 116.427 319.511C116.427 302.467 102.625 288.65 85.5993 288.65C68.5736 288.65 54.7715 302.467 54.7715 319.511C54.7715 336.555 68.5736 350.372 85.5993 350.372Z",
    fill: "#52A8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.175 51.4034C217.355 51.4034 228.849 39.8963 228.849 25.7017C228.849 11.507 217.355 0 203.175 0C188.996 0 177.501 11.507 177.501 25.7017C177.501 39.8963 188.996 51.4034 203.175 51.4034Z",
    fill: "#50AD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.618 51.4034C286.797 51.4034 298.292 39.8963 298.292 25.7017C298.292 11.507 286.797 0 272.618 0C258.438 0 246.943 11.507 246.943 25.7017C246.943 39.8963 258.438 51.4034 272.618 51.4034Z",
    fill: "#50AD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.674 103.403C340.854 103.403 352.348 91.8963 352.348 77.7017C352.348 63.507 340.854 52 326.674 52C312.495 52 301 63.507 301 77.7017C301 91.8963 312.495 103.403 326.674 103.403Z",
    fill: "#50AD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.421 165.11C152.601 165.11 164.095 153.603 164.095 139.409C164.095 125.214 152.601 113.707 138.421 113.707C124.242 113.707 112.747 125.214 112.747 139.409C112.747 153.603 124.242 165.11 138.421 165.11Z",
    fill: "#52A8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.088 225.028C188.268 225.028 199.762 213.521 199.762 199.327C199.762 185.132 188.268 173.625 174.088 173.625C159.909 173.625 148.414 185.132 148.414 199.327C148.414 213.521 159.909 225.028 174.088 225.028Z",
    fill: "#FFB772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.721 175.752C268.97 175.752 293.492 151.204 293.492 120.922C293.492 90.6401 268.97 66.0918 238.721 66.0918C208.471 66.0918 183.949 90.6401 183.949 120.922C183.949 151.204 208.471 175.752 238.721 175.752Z",
    fill: "#50AD87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.721 66.0918V175.752C268.97 175.752 293.492 151.204 293.492 120.922C293.492 90.6403 268.97 66.0918 238.721 66.0918Z",
    fill: "#439472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.854 14.498V124.159C473.104 124.159 497.626 99.61 497.626 69.3283C497.626 39.0466 473.104 14.498 442.854 14.498Z",
    fill: "#F37B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7716 279.858C85.0212 279.858 109.543 255.309 109.543 225.028C109.543 194.746 85.0212 170.197 54.7716 170.197C24.5221 170.197 0 194.746 0 225.028C0 255.309 24.5221 279.858 54.7716 279.858Z",
    fill: "#52A8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7715 170.197V279.858C85.0208 279.858 109.543 255.309 109.543 225.028C109.543 194.746 85.0208 170.197 54.7715 170.197Z",
    fill: "#4A91AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.197 248.8C515.376 248.8 526.871 237.293 526.871 223.098C526.871 208.904 515.376 197.396 501.197 197.396C487.017 197.396 475.522 208.904 475.522 223.098C475.522 237.293 487.017 248.8 501.197 248.8Z",
    fill: "#FFB772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.306 401.833L115.011 403.085C114.763 403.37 114.456 403.599 114.112 403.757C113.769 403.915 113.395 403.998 113.017 404C112.638 404.003 112.264 403.924 111.918 403.771C111.572 403.618 111.263 403.392 111.011 403.11L103.667 396.001C101.667 394.001 99.667 391.734 99.667 388.667C99.667 387.184 100.117 385.735 100.958 384.512C101.799 383.29 102.99 382.351 104.376 381.82C105.761 381.289 107.275 381.191 108.718 381.538C110.16 381.886 111.463 382.662 112.455 383.766C112.525 383.841 112.609 383.9 112.703 383.941C112.797 383.982 112.898 384.003 113 384.003C113.103 384.003 113.204 383.982 113.298 383.941C113.391 383.9 113.476 383.841 113.546 383.766C114.534 382.655 115.838 381.872 117.283 381.52C118.727 381.168 120.245 381.265 121.633 381.797C123.022 382.33 124.216 383.272 125.055 384.499C125.895 385.727 126.341 387.18 126.334 388.667C126.333 389.34 126.235 390.009 126.042 390.654",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 396H125",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 392V400",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.491 74.0576C317.321 73.2905 317.347 72.4929 317.567 71.7387C317.788 70.9844 318.195 70.2979 318.751 69.7429C319.307 69.1879 319.994 68.7823 320.749 68.5638C321.504 68.3452 322.301 68.3207 323.068 68.4926C323.49 67.8326 324.071 67.2895 324.759 66.9133C325.446 66.537 326.216 66.3398 327 66.3398C327.783 66.3398 328.554 66.537 329.241 66.9133C329.928 67.2895 330.509 67.8326 330.931 68.4926C331.699 68.32 332.498 68.3443 333.254 68.5634C334.01 68.7825 334.698 69.1893 335.255 69.7458C335.811 70.3023 336.218 70.9905 336.437 71.7464C336.656 72.5023 336.681 73.3014 336.508 74.0693C337.168 74.4913 337.711 75.0726 338.087 75.7597C338.464 76.4468 338.661 77.2176 338.661 78.0009C338.661 78.7843 338.464 79.555 338.087 80.2422C337.711 80.9293 337.168 81.5106 336.508 81.9326C336.68 82.6993 336.655 83.497 336.437 84.2517C336.218 85.0064 335.813 85.6937 335.258 86.2499C334.703 86.8061 334.016 87.2131 333.262 87.4332C332.508 87.6534 331.71 87.6795 330.943 87.5093C330.522 88.1718 329.94 88.7172 329.252 89.0951C328.563 89.473 327.791 89.6712 327.006 89.6712C326.22 89.6712 325.448 89.473 324.76 89.0951C324.071 88.7172 323.49 88.1718 323.068 87.5093C322.301 87.6812 321.504 87.6567 320.749 87.4381C319.994 87.2195 319.307 86.8139 318.751 86.2589C318.195 85.7039 317.788 85.0175 317.567 84.2632C317.347 83.5089 317.321 82.7113 317.491 81.9443C316.826 81.5234 316.279 80.9411 315.899 80.2517C315.519 79.5622 315.32 78.788 315.32 78.0009C315.32 77.2139 315.519 76.4396 315.899 75.7502C316.279 75.0607 316.826 74.4785 317.491 74.0576Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.333 73.334H331.666",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.333 78H331.666",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.166 83.834L322.333 82.6673H323.5C324.737 82.6673 325.924 82.1757 326.8 81.3005C327.675 80.4253 328.166 79.2383 328.166 78.0007C328.166 76.763 327.675 75.576 326.8 74.7008C325.924 73.8256 324.737 73.334 323.5 73.334",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.56 265.562C576.798 265.457 577.001 265.284 577.142 265.065C577.284 264.846 577.358 264.59 577.355 264.329C577.352 264.068 577.273 263.814 577.127 263.597C576.981 263.381 576.775 263.212 576.534 263.112L565.106 257.906C564.759 257.748 564.382 257.666 564 257.666C563.618 257.666 563.24 257.748 562.893 257.906L551.466 263.106C551.229 263.21 551.027 263.381 550.885 263.598C550.743 263.815 550.668 264.069 550.668 264.328C550.668 264.587 550.743 264.84 550.885 265.057C551.027 265.274 551.229 265.445 551.466 265.549L562.893 270.76C563.24 270.918 563.618 271 564 271C564.382 271 564.759 270.918 565.106 270.76L576.56 265.562Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.333 264.334V272.334",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 267.666V272.333C556 273.394 556.843 274.411 558.343 275.161C559.843 275.911 561.878 276.333 564 276.333C566.122 276.333 568.157 275.911 569.657 275.161C571.157 274.411 572 273.394 572 272.333V267.666",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 97V75.6667C451 74.9594 450.719 74.2811 450.219 73.781C449.719 73.281 449.041 73 448.333 73H437.667C436.959 73 436.281 73.281 435.781 73.781C435.281 74.2811 435 74.9594 435 75.6667V97",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 67.6666C419 66.8908 419.169 66.1243 419.495 65.4206C419.822 64.7168 420.298 64.0928 420.891 63.592L439.557 47.592C440.52 46.7784 441.74 46.332 443 46.332C444.26 46.332 445.48 46.7784 446.443 47.592L465.109 63.592C465.702 64.0928 466.178 64.7168 466.505 65.4206C466.831 66.1243 467 66.8908 467 67.6666V91.6666C467 93.0811 466.438 94.4377 465.438 95.4379C464.438 96.4381 463.081 97 461.667 97H424.333C422.919 97 421.562 96.4381 420.562 95.4379C419.562 94.4377 419 93.0811 419 91.6666V67.6666Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.666 108L212.333 110.667",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.667 108H244.334",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.666 110.667L260.333 108",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255 100H223C220.055 100 217.667 102.388 217.667 105.333V137.333C217.667 140.279 220.055 142.667 223 142.667H255C257.946 142.667 260.334 140.279 260.334 137.333V105.333C260.334 102.388 257.946 100 255 100Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.667 121.334H260.334",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M228.333 132H228.36",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M249.667 132H249.694",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223 142.666V147.999",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M255 147.999V142.666",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3333 217.429V210.667C60.3333 207.838 61.4571 205.125 63.4575 203.124C65.4579 201.124 68.171 200 71 200H75C75.3536 200 75.6928 200.14 75.9428 200.391C76.1929 200.641 76.3333 200.98 76.3333 201.333V205.333C76.3333 208.162 75.2095 210.875 73.2091 212.876C71.2087 214.876 68.4956 216 65.6667 216C62.8377 216 60.1246 217.124 58.1242 219.124C56.1238 221.125 55 223.838 55 226.667C55 232 57.6667 234.667 57.6667 240C57.6667 242.885 56.731 245.692 55 248",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.667 216.001C35.6479 214.515 38.0034 213.61 40.4696 213.388C42.9357 213.165 45.4151 213.634 47.6298 214.742C49.8446 215.849 51.7072 217.551 53.009 219.658C54.3108 221.764 55.0003 224.191 55.0003 226.667C53.0194 228.153 50.6639 229.058 48.1977 229.28C45.7316 229.502 43.2522 229.034 41.0375 227.926C38.8227 226.819 36.9601 225.117 35.6583 223.01C34.3565 220.904 33.667 218.477 33.667 216.001Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.333 248H73.6663",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M203 34V36",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M203 16V18",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M208 34V36",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M208 16V18",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M193 26H195",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M193 31H195",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M193 21H195",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M211 26H213",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M211 31H213",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M211 21H213",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M198 34V36",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M198 16V18",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M209 18H197C195.895 18 195 18.8954 195 20V32C195 33.1046 195.895 34 197 34H209C210.105 34 211 33.1046 211 32V20C211 18.8954 210.105 18 209 18Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M206 22H200C199.448 22 199 22.4477 199 23V29C199 29.5523 199.448 30 200 30H206C206.552 30 207 29.5523 207 29V23C207 22.4477 206.552 22 206 22Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6667 323.999H87.3333C88.0406 323.999 88.7189 323.718 89.219 323.218C89.719 322.718 90 322.04 90 321.333C90 320.625 89.719 319.947 89.219 319.447C88.7189 318.947 88.0406 318.666 87.3333 318.666H83.3333C82.5333 318.666 81.8667 318.933 81.4667 319.466L74 326.666",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M79.333 332L81.4663 330.134C81.8663 329.6 82.533 329.334 83.333 329.334H88.6663C90.133 329.334 91.4663 328.8 92.3997 327.734L98.533 321.867C99.0475 321.381 99.3478 320.71 99.3678 320.002C99.3878 319.295 99.1259 318.608 98.6397 318.094C98.1534 317.579 97.4827 317.279 96.7751 317.259C96.0675 317.239 95.3809 317.501 94.8663 317.987L89.2663 323.187",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.667 325.334L80.667 333.334",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3335 319.866C93.469 319.866 95.2001 318.135 95.2001 315.999C95.2001 313.864 93.469 312.133 91.3335 312.133C89.198 312.133 87.4668 313.864 87.4668 315.999C87.4668 318.135 89.198 319.866 91.3335 319.866Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M78 314.666C80.2091 314.666 82 312.875 82 310.666C82 308.457 80.2091 306.666 78 306.666C75.7909 306.666 74 308.457 74 310.666C74 312.875 75.7909 314.666 78 314.666Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M345 157.334H345.013",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M350.333 157.334H350.346",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M333 161.333C333 162.041 333.281 162.719 333.781 163.219C334.281 163.719 334.959 164 335.667 164H354.333C355.041 164 355.719 163.719 356.219 163.219C356.719 162.719 357 162.041 357 161.333V147.333C357 147.214 356.968 147.096 356.907 146.993C356.846 146.89 356.759 146.806 356.654 146.748C356.549 146.691 356.431 146.662 356.311 146.666C356.192 146.67 356.075 146.706 355.975 146.771L350.025 150.563C349.925 150.627 349.808 150.663 349.689 150.667C349.569 150.671 349.451 150.643 349.346 150.585C349.241 150.528 349.154 150.443 349.093 150.34C349.032 150.237 349 150.12 349 150V147.333C349 147.214 348.968 147.096 348.907 146.993C348.846 146.89 348.759 146.806 348.654 146.748C348.549 146.691 348.431 146.662 348.311 146.666C348.192 146.67 348.075 146.706 347.975 146.771L342.027 150.563C341.926 150.627 341.809 150.664 341.69 150.668C341.57 150.672 341.451 150.644 341.346 150.586C341.241 150.529 341.154 150.444 341.093 150.341C341.032 150.237 341 150.12 341 150V142.667C341 141.959 340.719 141.281 340.219 140.781C339.719 140.281 339.041 140 338.333 140H335.667C334.959 140 334.281 140.281 333.781 140.781C333.281 141.281 333 141.959 333 142.667V161.333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M339.667 157.334H339.68",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M535.334 381.334H528.667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M536.667 370.666H528.667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M539.334 376H528.667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M523.333 364C523.333 363.646 523.473 363.307 523.724 363.057C523.974 362.807 524.313 362.666 524.666 362.666C524.997 362.664 525.32 362.757 525.6 362.933L526.844 363.733C527.122 363.911 527.446 364.006 527.777 364.006C528.108 364.006 528.432 363.911 528.71 363.733L529.956 362.933C530.234 362.755 530.558 362.66 530.889 362.66C531.22 362.66 531.544 362.755 531.822 362.933L533.066 363.733C533.345 363.911 533.669 364.006 534 364.006C534.33 364.006 534.654 363.911 534.933 363.733L536.177 362.933C536.456 362.755 536.78 362.66 537.11 362.66C537.441 362.66 537.765 362.755 538.044 362.933L539.289 363.733C539.568 363.911 539.892 364.006 540.222 364.006C540.553 364.006 540.877 363.911 541.156 363.733L542.4 362.933C542.679 362.757 543.003 362.664 543.333 362.666C543.687 362.666 544.026 362.807 544.276 363.057C544.526 363.307 544.666 363.646 544.666 364V388C544.666 388.353 544.526 388.692 544.276 388.942C544.026 389.192 543.687 389.333 543.333 389.333C543.003 389.335 542.679 389.242 542.4 389.066L541.156 388.266C540.877 388.088 540.553 387.993 540.222 387.993C539.892 387.993 539.568 388.088 539.289 388.266L538.044 389.066C537.765 389.244 537.441 389.339 537.11 389.339C536.78 389.339 536.456 389.244 536.177 389.066L534.933 388.266C534.654 388.088 534.33 387.993 534 387.993C533.669 387.993 533.345 388.088 533.066 388.266L531.822 389.066C531.544 389.244 531.22 389.339 530.889 389.339C530.558 389.339 530.234 389.244 529.956 389.066L528.71 388.266C528.432 388.088 528.108 387.993 527.777 387.993C527.446 387.993 527.122 388.088 526.844 388.266L525.6 389.066C525.32 389.242 524.997 389.335 524.666 389.333C524.313 389.333 523.974 389.192 523.724 388.942C523.473 388.692 523.333 388.353 523.333 388V364Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M510.667 458.667L512.667 453.334L514.667 458.667C514.087 459.101 513.387 459.334 512.667 459.334C511.947 459.334 511.247 459.101 510.667 458.667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M501.333 458.667L503.333 453.334L505.333 458.667C504.753 459.101 504.053 459.334 503.333 459.334C502.613 459.334 501.913 459.101 501.333 458.667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M504.667 462H511.334",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M508 450V462",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M502 452.667H503.333C504.667 452.667 506.667 452.001 508 451.334C509.333 452.001 511.333 452.667 512.667 452.667H514",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M527 125.334V130.667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M529.666 144.001V140.001C529.666 139.293 529.385 138.615 528.885 138.115C528.385 137.615 527.707 137.334 527 137.334C526.292 137.334 525.614 137.615 525.114 138.115C524.614 138.615 524.333 139.293 524.333 140.001V144.001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M529.666 128H524.333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M535 130.666H537.667C538.374 130.666 539.053 130.947 539.553 131.447C540.053 131.947 540.334 132.625 540.334 133.333V141.333C540.334 142.04 540.053 142.718 539.553 143.218C539.053 143.718 538.374 143.999 537.667 143.999H516.334C515.626 143.999 514.948 143.718 514.448 143.218C513.948 142.718 513.667 142.04 513.667 141.333V129.333C513.667 128.625 513.948 127.947 514.448 127.447C514.948 126.947 515.626 126.666 516.334 126.666H519",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M535 144V122.667C535 121.959 534.719 121.281 534.219 120.781C533.719 120.281 533.041 120 532.333 120H521.667C520.959 120 520.281 120.281 519.781 120.781C519.281 121.281 519 121.959 519 122.667V144",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M503.832 228.568C504.039 228.663 504.271 228.685 504.492 228.629C504.712 228.574 504.907 228.446 505.045 228.265L505.4 227.8C505.586 227.552 505.828 227.35 506.106 227.211C506.383 227.072 506.69 227 507 227H510C510.53 227 511.039 227.211 511.414 227.586C511.789 227.961 512 228.47 512 229V232C512 232.53 511.789 233.039 511.414 233.414C511.039 233.789 510.53 234 510 234C505.226 234 500.648 232.104 497.272 228.728C493.896 225.352 492 220.774 492 216C492 215.47 492.211 214.961 492.586 214.586C492.961 214.211 493.47 214 494 214H497C497.53 214 498.039 214.211 498.414 214.586C498.789 214.961 499 215.47 499 216V219C499 219.31 498.928 219.617 498.789 219.894C498.65 220.172 498.448 220.414 498.2 220.6L497.732 220.951C497.548 221.091 497.419 221.291 497.366 221.515C497.313 221.74 497.339 221.976 497.44 222.184C498.807 224.96 501.054 227.205 503.832 228.568Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M287.667 205.334C287.541 205.334 287.417 205.299 287.31 205.232C287.203 205.165 287.118 205.069 287.063 204.955C287.009 204.841 286.988 204.714 287.003 204.589C287.017 204.464 287.068 204.345 287.147 204.247L293.747 197.447C293.796 197.39 293.864 197.351 293.938 197.338C294.013 197.324 294.089 197.336 294.156 197.371C294.223 197.407 294.275 197.464 294.305 197.534C294.335 197.603 294.34 197.681 294.32 197.754L293.04 201.767C293.003 201.868 292.99 201.977 293.003 202.084C293.017 202.191 293.056 202.293 293.118 202.381C293.179 202.47 293.262 202.542 293.357 202.592C293.453 202.642 293.559 202.667 293.667 202.667H298.334C298.46 202.667 298.583 202.702 298.69 202.769C298.797 202.836 298.883 202.932 298.937 203.046C298.992 203.16 299.013 203.287 298.998 203.412C298.983 203.537 298.933 203.656 298.854 203.754L292.254 210.554C292.204 210.611 292.137 210.65 292.062 210.663C291.988 210.677 291.911 210.665 291.845 210.629C291.778 210.594 291.725 210.537 291.695 210.467C291.666 210.398 291.66 210.32 291.68 210.247L292.96 206.234C292.998 206.133 293.011 206.024 292.997 205.917C292.984 205.81 292.945 205.708 292.883 205.619C292.821 205.531 292.739 205.459 292.643 205.409C292.548 205.359 292.441 205.333 292.334 205.334H287.667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_29501_30294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M556.334 204.667C556.702 204.667 557 204.369 557 204.001C557 203.632 556.702 203.334 556.334 203.334C555.965 203.334 555.667 203.632 555.667 204.001C555.667 204.369 555.965 204.667 556.334 204.667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.667 204.667C564.035 204.667 564.333 204.369 564.333 204.001C564.333 203.632 564.035 203.334 563.667 203.334C563.298 203.334 563 203.632 563 204.001C563 204.369 563.298 204.667 563.667 204.667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.366 191.367H553.7L555.473 199.647C555.538 199.95 555.707 200.222 555.95 200.414C556.193 200.606 556.496 200.707 556.806 200.701H563.326C563.63 200.7 563.924 200.596 564.16 200.406C564.397 200.215 564.561 199.95 564.626 199.654L565.726 194.701H554.413",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29501_30294",
    x1: 148.306,
    y1: 261.105,
    x2: 108.731,
    y2: 298.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17414C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#377077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29501_30294",
    x1: 513.489,
    y1: 162.251,
    x2: 450.174,
    y2: 162.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#207F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#377077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17414C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29501_30294",
    x1: 455.436,
    y1: 347.496,
    x2: 497.744,
    y2: 292.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17414C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#377077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29501_30294",
    x1: 198.264,
    y1: 478.666,
    x2: 198.264,
    y2: 358.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17414C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#377077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_29501_30294",
    x1: 430.472,
    y1: 478.668,
    x2: 430.472,
    y2: 358.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17414C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#377077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_29501_30294",
    x1: 222.438,
    y1: 275.547,
    x2: 92.6882,
    y2: 233.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17414C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#377077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_29501_30294",
    x1: 228.45,
    y1: 323.611,
    x2: 308.552,
    y2: 323.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#356D74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_29501_30294",
    x1: 375.704,
    y1: 104.255,
    x2: 375.704,
    y2: 426.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#207F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#377077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17414C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_29501_30294",
    x1: 380.839,
    y1: 441.38,
    x2: 380.839,
    y2: 561.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17414C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#377077"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29501_30294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 598,
    height: 552,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_29501_30294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(551 190)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.b91a268523e6e548fb0bb538177ca4f5.svg";
export { ForwardRef as ReactComponent };